import { Link } from '@mui/material';
import { isEmpty } from 'lodash';
import React, { Fragment, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { payoutManualApi } from 'api';
import { DescriptionRow } from 'components';
import { QueryKey } from 'enums';
import { TranslationNamespace } from 'i18n';

import { PayoutManualHistoryDialog } from './PayoutManualHistoryDialog';

type Props = {
  orderId: string;
};

export const PayoutManualHistory: React.FC<Props> = ({ orderId }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.manual',
  });
  const { t: tCommon } = useTranslation(TranslationNamespace.Common);

  const [dialogOpen, setDialogOpen] = useState(false);

  // Loaded up front (not on open like the other sections): the row itself must disappear when the
  // order was never handled manually, and that is only knowable from the response.
  const queryResult = useQuery(
    [QueryKey.PayoutOrderManualBatches, orderId],
    () => payoutManualApi.getOrderBatches(orderId),
    { enabled: !!orderId },
  );

  const handleOpen = useCallback(() => setDialogOpen(true), []);
  const handleClose = useCallback(() => setDialogOpen(false), []);

  const hasHistory = useMemo(
    () => !isEmpty(queryResult.data),
    [queryResult.data],
  );

  if (!hasHistory) {
    return null;
  }

  return (
    <Fragment>
      <DescriptionRow
        title={t('history_title')}
        value={
          <div>
            <Link
              component="button"
              variant="body2"
              underline="none"
              onClick={handleOpen}
            >
              {tCommon('buttons.open')}
            </Link>
          </div>
        }
      />
      <PayoutManualHistoryDialog
        queryResult={queryResult}
        open={dialogOpen}
        onClose={handleClose}
      />
    </Fragment>
  );
};
